import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import StandardFoodListTabs from "@/components/menu-management/standard-foods/standard-foods-list/standard-foot-list-tabs";
import DraftListTabs from "@/components/menu-management/standard-foods/standard-foods-list/draft-list-tabs";
import useAuth from "@/hooks/useAuth";
import {
  fetchAllStandardFoods,
  clearStandardFoodMessages,
} from "@/redux/slice/menu-manage-slice/standard-food-slice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import TableSkeleton from "@/components/skeleton/table-skeletion";
import hasPermission from "@/hooks/hasPermission";

function StandardFood() {
  const { user } = useAuth();
  const dispatch = useDispatch();
  const { getLoading } = useSelector((state) => state.menuManage.standardFood);

  useEffect(() => {
    dispatch(fetchAllStandardFoods(user.restaurant_id));
    clearStandardFoodMessages();
  }, [user.restaurant_id]);

 
   if (getLoading) return <TableSkeleton links={backofficeLinks} />;

  return (
    <Layout2
      pageName={{ title: "Standard Foods list" }}
      paths={[
        { name: "home", path: "/home" },
        { name: "Back Office", path: "/backoffice/overview" },
        { name: "Menu Management", path: "/backoffice/menu/drinks" },
        { name: "Standard Foods", path: "/backoffice/menu/standard-foods" },
      ]}
      LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
    >
      <div className="container flex flex-col gap-4 mt-5">
   <div className="flex justify-end items-start md:items-center md:flex-row flex-col  w-full">
    
          {hasPermission("back_office.menu_management.create_standard_food") && (
            <Link to={"/backoffice/menu/standard-foods/create"}>
              <Button>
                <Plus /> Create Standard Food
              </Button>
            </Link>
          )}
        </div>
        <Tabs valueKey="menu-standard-foods" className="bg-transparent relative" defaultValue="drink">
          <TabsList className="grid grid-cols-6 w-full">
            <Separator className="absolute top-8 " />
            <TabsTrigger className="bg-transparent" value="drink">
              Standard Food List
            </TabsTrigger>
            <TabsTrigger value="draft">Draft List</TabsTrigger>
          </TabsList>
          <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
          <StandardFoodListTabs />
          <DraftListTabs />
        </Tabs>
      </div>
    </Layout2>
  );
}

export default StandardFood;
